import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FeatureAggregationService } from '@y42/feature';
import { AbstractFeatureChildUIModel } from '@y42/feature';
import { Y42FeatureTypeToRoute, Y42RouteDetailTab, Y42RouterService } from '@y42/feature/routing';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class FeatureRouterService {
  constructor(
    private readonly featureAggregationService: FeatureAggregationService,
    private readonly router: Y42RouterService,
  ) {}

  navigateToDetail(
    $path: string,
    config: {
      tab?: Y42RouteDetailTab;
      subId?: string;
      queryParams?: Params;
    } = {},
  ) {
    const tableOrDatasourceServiceDef = this.featureAggregationService.getServiceDefinitionByPath($path);
    const tableOrDatasource = tableOrDatasourceServiceDef?.query.getUIEntity($path);

    let featureType = tableOrDatasourceServiceDef?.featureType;
    let $name = tableOrDatasourceServiceDef?.query.getEntity($path)?.$name;

    const parentFilePath$ = (tableOrDatasource as AbstractFeatureChildUIModel).$parent;
    if (parentFilePath$) {
      const datasourceServiceDef = this.featureAggregationService.getServiceDefinitionByPath(parentFilePath$);
      featureType = datasourceServiceDef?.featureType;
      $name = datasourceServiceDef?.query.getEntity(parentFilePath$)?.$name;
    }

    if (featureType) {
      const route = Y42FeatureTypeToRoute[featureType];
      if (route && $name) {
        this.router.navigateToDetail(route, $name, config.tab, config.subId, config.queryParams);
      }
    }
  }
}
